import Layout from "../include/layout";
import { Badge, Button, Container, Form, Modal, Table } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import $ from "jquery";
import dayjs from "dayjs";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { myroutes } from "../../routes/webroute";
import Swal from "sweetalert2";
import { checkAuthenticate } from "../app/providers/authSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "datatables.net-bs5";
import EnseignantsService from "../enseignants/EnseignantsService";
import Filarial from "../include/filarial";
import PersonnesService from "../personnes/PersonnesService";
import MatieresService from "../matieres/MatieresService";
import UsersService from "../users/UsersService";
import CivilitesService from "../civilites/CivilitesService";
import PaysService from "../pays/PaysService";
import TypescontratsService from "../typescontrats/TypescontratsService";
import ClassesoptionsService from "../classesoptions/ClassesoptionsService";
import ClassesService from "../classe/ClassesService";
import { ConnectedOverlayScrollHandler } from "primereact/utils";
import CoursService from "../cours/CoursService";
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { transform } from "joi-browser";

export default function EmploidutempsEnseignant() {
  const activeLink = "EMPLOI DU TEMPS ENSEIGNANTS";

  const navigate = useNavigate();
  //check if user is authenticated
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticate);

  ///les elements du modal details
  const token = useSelector((state) => state.auth.token);
  const [enseignants, setEnseignants] = useState([]);
  const [personnes, setPersonnes] = useState([]);
  const [users, setUsers] = useState([]);
  const [matiere, setMatiere] = useState("");
  const [matieres, setMatieres] = useState([]);
  const [jours, setJours] = useState([]);
  const [classeoptions, setClasseoptions] = useState([]);
  const [classeoption, setClasseoption] = useState("");
  const [classes, setClasses] = useState([]);
  const [classesmatieres, setClassesmatieres] = useState([]);
  const [idenseignant, setIdenseignant] = useState("");
  const [cours, setCours] = useState([]); // Les données de tous les cours
  const [coursfiltrers, setCoursfiltrers] = useState([]); // Les données des filtrés
  const [loading, setLoading] = useState(true); 

  const location = useLocation();

    useEffect(() => {
    const idEnseignant = location.state && location.state.id;
   // console.log("enseignant_id", idEnseignant);
  }, [location]);


 //get liste cours by enseignants
 const fetchCoursEnseignants = async () => {
  try {
    const response = await CoursService.getCoursByEnseignants(location.state.id, token);
    const data = response.data.data;
   // console.log("data", data)
    setCoursfiltrers(data);
  } catch (error) {
    console.log(error);

     //initialize datatable
     $(document).ready(function () {
      $('.data-table').DataTable();
  });
  }
};
    
    //get liste cours
    const fetchCours = async () => {
        await CoursService.index(token)
          .then((res) => {
        // console.log(res.data.data.cours)
            setCours(res.data.data.cours);
          })
          .catch((error) => {
            console.log(error);
          });
      };
    

  //get liste enseignants
  const fetchEnseignants = async () => {
    await EnseignantsService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setEnseignants(res.data.data.enseignants);
      })
      .catch((error) => {
        console.log(error);
      });
       //initialize datatable
       $(document).ready(function () {
        $('.data-table').DataTable();
    });
  };

  //get liste personnes
  const fetchPersonnes = async () => {
    await PersonnesService.index(token)
      .then((res) => {
        //  console.log(res.data.data.personnes)
        setPersonnes(res.data.data.personnes);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  //get liste matières
  const fetchMatieres = async () => {
    await MatieresService.index(token)
      .then((res) => {
        //console.log(res.data.data)
        setMatieres(res.data.data.matieres);
      })
      .catch((error) => {
        console.log(error);
      });
  };


  ///Get liste des classesoptions
  const fetchClassesoptions = async () => {
    await ClassesoptionsService.index(token)
      .then((res) => {
        setClasseoptions(res.data.data.classesoptions);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "numeric", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  //redirection sur la page edit sans afficher les id dans l'url
  const goToEdit = (param) => {
    navigate(myroutes.cours_edit, { state: { id: param } });
  };

  //suppression d'un élément
  const onDelete = (param) => {
    //confirm action
    Swal.fire({
      icon: "warning",
      text: "Voulez-vous confirmer cette action ?",
      showCancelButton: true,
      cancelButtonText: "Non",
      confirmButtonText: "Oui",
      confirmButtonColor: "red",
    }).then((result) => {
      if (result.isConfirmed) {
        EnseignantsService.delete(param, token)
          .then((response) => {
            if (response.data.status !== 200) {
              Swal.fire({
                icon: "error",
                text: response.data.message,
              });
            } else {
              Swal.fire({
                icon: "success",
                text: response.data.message,
              });
              fetchEnseignants();
            }
          })
          .catch((e) => {
            Swal.fire({
              icon: "error",
              text: e.message,
            });
            console.log(e);
          });
      }
    });
  };

  //métode pour afficher le nom et prénoms de l'ensiegnant une seule fois

  const nomsEnseignantsDejaVus = new Set(); 

const coursFiltresSansRepetitions = coursfiltrers.filter((item) => {
  const nomEnseignant = item.enseignants.personnes.nomPersonne;
  if (!nomsEnseignantsDejaVus.has(nomEnseignant)) {
    nomsEnseignantsDejaVus.add(nomEnseignant);
    return true; 
  }
  return false; 
});

   //get liste jours
   const fetchJours = async () => {
    await CoursService.index_jours(token).then((res) => {
        setJours(res.data.data.jours)
    }).catch(error => {
        console.log(error)
    })
}

const emploiDuTempsReorganise = {};

coursfiltrers.forEach((item) => {
  const jour = item.jours.libelleJour;
  const heureDebut = item.heuredebutCours.substring(0, 5);
  const heureFin = item.heurefinCours.substring(0, 5);
  const classe = item.classesoptions.libelleClasseOption;
  const matiere = item.matieres.libelleMatiere;

  if (!emploiDuTempsReorganise[jour]) {
    emploiDuTempsReorganise[jour] = {};
  }

  if (!emploiDuTempsReorganise[jour][heureDebut]) {
    emploiDuTempsReorganise[jour][heureDebut] = {};
  }

  emploiDuTempsReorganise[jour][heureDebut][heureFin] = {
    classe,
    matiere,
  };
});


const generatePDF = () => {
  const doc = new jsPDF('landscape');

  // Ajouter un background à l'entête
 /* doc.setFillColor(245)*/; // Gris clair
  doc.rect(5, 5, 285, 35);  
    doc.setLineWidth(0.2)
    doc.setDrawColor(0)

    // Ajouter un en-tête avec un logo
    const logo = new Image();
    logo.src = '/images/logo_gs_sans_fond.png'; 
    doc.addImage(logo, 'PNG', 10, 10, 30, 30); 

    // Ajouter les textes d'en-tête
    doc.setFontSize(12);
    doc.setTextColor(0, 0, 0); 
    doc.text('Complexe scolaire G-Schoolarys', 80, 20); 
    doc.text('1788039938393', 80, 30); 

    // Ajouter de l'espace entre les textes
    doc.setFontSize(16);

  // Encadrer le texte
 /* doc.setDrawColor(0); 
  doc.setLineWidth(0.2); 
  doc.rect(0, 0, 50,0); */
  doc.text('Emploi du temps enseignant', 15, 55); 
  

  // Styles pour les cellules du tableau
const cellStyles = {
  padding: 5,
  lineHeight: 1.2,
  fillColor: [255, 255, 255], 
  textColor: [0, 0, 0], 
  fontSize: 10,
  fontStyle: 'normal', 
  lineColor: [0, 0, 0], 
};

const tableData = [];

// Créer un tableau avec l'ordre normal des jours de la semaine
const emploiDuTempsParJour = {
  Dimanche: [],
  Lundi: [],
  Mardi: [],
  Mercredi: [],
  Jeudi: [],
  Vendredi: [],
  Samedi: [],
};

 
  // Dupliquer la table pour éviter de modifier l'originale
  const tableElement = document.getElementById('my-table-enseignant');
  const tableCopy = tableElement.cloneNode(true);

  // Supprimer la colonne "Action" de la copie
  const headerCellToRemove = tableCopy.querySelector('thead th:last-child');
  const bodyCellsToRemove = tableCopy.querySelectorAll('tbody td:last-child');

  if (headerCellToRemove) {
    headerCellToRemove.remove();
  }
  bodyCellsToRemove.forEach(cell => cell.remove());

  // Trier les données en fonction des jours de la semaine
  const tbody = tableCopy.querySelector('tbody');
  const rows = Array.from(tbody.querySelectorAll('tr'));
  const donnees = rows.map(row => {
    const cells = row.querySelectorAll('td');
    return {
      //lignes du tableau
    jourSemaine: cells[0] ? cells[0].textContent : '',
    heureDebut: cells[1] ? cells[1].textContent : '',
    heureFin: cells[2] ? cells[2].textContent : '',
    matiere: cells[3] ? cells[3].textContent : '',
    classes: cells[4] ? cells[4].textContent : ''
    };
  });
  

  tbody.innerHTML = ''; // Effacer le contenu actuel du corps de la table

 // Organiser les données en fonction des jours de la semaine
 donnees.forEach(donnee => {
  emploiDuTempsParJour[donnee.jourSemaine].push({
    jourSemaine: donnee.jourSemaine,
    heureDebut: donnee.heureDebut,
    heureFin: donnee.heureFin,
    matiere: donnee.matiere,
    classes: donnee.classes,
  });
});

 // Créer une structure de données pour le tableau complet
 Object.entries(emploiDuTempsParJour).forEach(([jour, emploisDuTemps]) => {
  if (emploisDuTemps.length > 0) {
    // Ajouter le jour pour la première ligne seulement
    let firstRow = true;

    emploisDuTemps.forEach(emploi => {
      const rowData = [];
      if (firstRow) {
        rowData.push(jour);
        firstRow = false;
      } else {
        // Pour les lignes suivantes, ajouter une cellule vide pour le jour
        rowData.push('');
      }
      rowData.push(emploi.heureDebut, emploi.heureFin, emploi.matiere, emploi.classes);
      tableData.push(rowData);
    });
  }
});

// Générer le PDF avec un seul tableau pour tous les jours
doc.autoTable({
  head: [['Jour', 'Heure Début', 'Heure Fin', 'Classes', 'Matière']],
  body: tableData,
  startY: 70,
  theme: 'grid',
  styles: {
    styles: cellStyles,
    headStyles: { fillColor: [0, 0, 74], textColor: [255, 255, 255] },
  },
});

  // Enregistrez le PDF
  doc.save('emploi_du_temps.pdf');
  // Afficher un message de succès avec style
  const successMessage = document.createElement('div');
  successMessage.style.backgroundColor = '#4CAF50';
  successMessage.style.color = 'white';
  successMessage.style.padding = '10px 20px';
  successMessage.style.borderRadius = '5px';
  successMessage.style.position = 'fixed';
  successMessage.style.bottom = '20px';
  successMessage.style.right = '20px';
  successMessage.textContent = 'Le PDF a été généré et téléchargé avec succès!';
  document.body.appendChild(successMessage);

  // Disparition automatique de l'alerte après quelques secondes
  setTimeout(() => {
    successMessage.style.display = 'none';
  }, 3000);
};




  useEffect(() => {
    fetchEnseignants();
    fetchPersonnes();
    fetchClassesoptions();
    fetchMatieres();
    fetchCoursEnseignants();
    fetchCours();
    fetchJours();
    // Vérifier si l'utilisateur est connecté lors du chargement de l'application
    dispatch(checkAuthenticate());
    if (!isAuthenticated) {
      //console.log(isAuthenticated)
      //Redirection sur le dashboard
      navigate(myroutes.login);
    }
  }, [dispatch]);

  return (
    <Layout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Filarial activeLink={activeLink} />
        <div className="card mt-3" >
        <div className="card-header" style={{maxHeight:"75px", textAlign:"center"}}>
      {coursFiltresSansRepetitions.length > 0 &&
        coursFiltresSansRepetitions.map((item, index) => (
              <span  key={index} >
            <h5>
            Mme/Mr {' '}<Badge bg="secondary"> {item.enseignants.personnes.nomPersonne + ' ' + item.enseignants.personnes.prenomsPersonne}</Badge>
           </h5> 
          </span>
        ))}
        </div>
        </div>
        <div className="row mt-3">
             <div className="col-12">
                <b>Imprimer :</b> <span><button type="button" className="btn btn-danger" onClick={generatePDF}><i className="fas fa-file-pdf"></i>&nbsp;PDF</button></span> &nbsp;&nbsp; 
                <span>{/*<button type="button" className="btn btn-success"><i className="far fa-file-excel"></i> &nbsp;Excel</button>*/}</span>
             </div>
        </div>
        {/* Responsive Datatable */}
        <div className="card shadow-lg mb-3 mt-3">
          <h5 className="card-header">
            Emploi du temps {" "}
            <Link
              className="btn btn-primary btn-sm"
              to={myroutes.enseignants_index}
              title="Ajouter"
            >
              Retour sur la liste des enseignants
            </Link>
          </h5>
          <div className="card-datatable table-responsive px-4 pb-3">
            <table  id="my-table-enseignant" className="dt-responsive table border-top data-table table-hover ">
              <thead className="fw-bold theme-bg-blue-white ">
                <tr style={{ color: "" }}>
                  <th className="cell">Jours</th>
                  <th className="cell">Heure debut</th>
                  <th className="cell">Heure fin</th>
                  <th className="cell">Classes</th>
                  <th className="cell">Matières</th>
                  <th className="cell">Action</th>
                </tr>
              </thead>
              <tbody>
                {coursfiltrers.length > 0 &&
                  coursfiltrers.map((item, index) => (
                    <tr key={index}>
                      <td className="cell">
                       {item.jours.libelleJour}
                      </td>
                      <td className="cell">
                      {item.heuredebutCours.substring(0, 5)}
                      </td>
                      <td className="cell">
                      {item.heurefinCours.substring(0, 5)}
                       </td>
                      <td className="cell">{item.classesoptions.libelleClasseOption}</td>
                      <td className="cell">{item.matieres.libelleMatiere}</td>                      
                      <td className="cell">
                        <div className="d-flex">
                          &nbsp;&nbsp;
                          <Button
                            className="btn btn-sm"
                            variant="primary"
                            onClick={() => goToEdit(item.id)}
                            title="Modifier"
                          >
                            <i className="fas fa-edit"></i>
                          </Button>{" "}
                          &nbsp;&nbsp;
                          
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {/*/ Responsive Datatable */}
        {/* /Bootstrap Validation */}
      </div>
    </Layout>
  );
}
